module.exports = __webpack_public_path__ + "static/media/barmag2c2.bee43a87.jpg";